// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"4ea6ad93","186":"a2a885a9","225":"d024957b","344":"a1c1df4f","372":"d27deec3","496":"f4f4aa54","738":"cd4f85f5","841":"b4c78bf6","856":"a5349edc"}[chunkId] + ".chunk.js";
};